import type { ReactNode } from 'react'
import type { QueryClient } from '@tanstack/react-query'
import { QueryClientProvider } from '@tanstack/react-query'
import type { i18n } from 'i18next'
import { I18nextProvider } from 'react-i18next'
import type { ApiClient, TokenStore } from '@dorixona/api'
import { createAppI18n } from './i18n'
import { SessionProvider } from '../features/auth/session'
import type { AdminAuthApi, AdminMe } from '../features/auth/api'
import { createAdminAuthApi } from '../features/auth/api'
import { ApiProvider } from '../api/context'
import { api as appApi, tokenStore as appTokenStore } from '../api/client'
import { createQueryClient } from './queryClient'

export interface AppProvidersProps {
  children: ReactNode
  queryClient?: QueryClient
  i18nInstance?: i18n
  /** Клиент API для экранов; тест подставляет свой. */
  api?: ApiClient
  /** Готовый профиль: так тесты экранов открываются без входа и без сети. */
  initialMe?: AdminMe
  authApi?: AdminAuthApi
  tokenStore?: TokenStore
}

export function AppProviders({
  children,
  queryClient,
  i18nInstance,
  api,
  initialMe,
  authApi,
  tokenStore,
}: AppProvidersProps) {
  const client = queryClient ?? createQueryClient()
  const i18n = i18nInstance ?? createAppI18n()
  const apiClient = api ?? appApi
  const auth = authApi ?? createAdminAuthApi(apiClient)
  return (
    <QueryClientProvider client={client}>
      <I18nextProvider i18n={i18n}>
        <ApiProvider api={apiClient}>
          <SessionProvider
            api={auth}
            tokenStore={tokenStore ?? appTokenStore}
            initialMe={initialMe}
          >
            {children}
          </SessionProvider>
        </ApiProvider>
      </I18nextProvider>
    </QueryClientProvider>
  )
}
